export class AuthService {

  constructor() {}

}
